$(document).ready(function() {
    //load_posts('Kaikki', 'new_category', posts_ppp);
});
//Load more button and category buttons
var pageNumber = 1;

function load_posts(category, load, posts_ppp) {
    var lang = 'fi'
    if ($(".lang-item-en").hasClass("current-lang")) lang = 'en'
    
    var load_more = 'Lataa lisää'
    if(lang == 'en') load_more = 'Load more' 
    
    if ( load == 'same_category') {
        pageNumber++; 
    }
    else {
        pageNumber = 1; 
    }
    var str = '&pageNumber=' + pageNumber + '&category=' + category + '&ppp=' + posts_ppp + '&action=more_post_ajax';
    $.ajax({
        type: "POST",
        dataType: "json",
        url: ajaxurl,
        data: str,
        success: function(data){
            if(data.html) {
                if( load == 'same_category') {
                    $("#ajax-posts").append(data.html);
                }
                else {
                    $("#ajax-posts").html(data.html);
                }
                if (data.last_one == false) {
                    $(".loadmore.posts").attr("disabled",false);
                    $(".loadmore.posts").html(load_more);
                    $(".loadmore.posts").show();
                }
                else {
                    $(".loadmore.posts").attr("disabled",false);
                    $(".loadmore.posts").hide();
                }

            } else{
                $(".loadmore.posts").attr("disabled",true);
                $(".loadmore.posts").hide();
            }
        },
        error : function(jqXHR, textStatus, errorThrown) {
            $loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
        }

    });
    return false;
}

var active_category_button = 'Kaikki';
var posts_ppp = $(".loadmore.posts").attr("data-ppp");

$(".loadmore.posts").on("click",function(){ // When btn is pressed.
    var lang = 'fi'
    if ($(".lang-item-en").hasClass("current-lang")) lang = 'en'
    var loading_more = 'Ladataan lisää...'
    if(lang == 'en') loading_more = 'Loading more...'

    $(".loadmore.posts").attr("disabled",true); // Disable the button, temp.
    $(".loadmore.posts").html(loading_more);
    load_posts(active_category_button, 'same_category', posts_ppp);
    $(this).insertAfter('.loadmore.posts'); // Move the 'Load More' button to the end of the the newly added posts.
})

$(".tags.posts > .button").on("click",function(){ // When btn is pressed.
    $(".loadmore.posts").attr("disabled",true); // Disable the button, temp.
    var category = $(this).attr("data-tag");
    active_category_button = category;
    if ( category == 'Kaikki') {
        load_posts('Kaikki', 'new_category', posts_ppp);
    }
    else {
        load_posts(category, 'new_category', posts_ppp);
    }
})